import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import PhotoItem from './PhotoItem'
import PhotoSlideShow from 'common/PhotoSlideShow/SlideShow'

export default class PhotosGroup extends React.Component {

  static propTypes = {
    mode: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      fullscreenVisible: false,
      selectedIdx: 0
    }
  }

  getGroupHeader = () => {
    if (this.props.mode === 'date') {
      return moment(this.props.header).format('ddd, MMM DD, YYYY')
    }
    return this.props.header
  }

  onImagePress = (selectedIdx) => {
    this.setState({ fullscreenVisible: true, selectedIdx })
  }

  onSlideShowClose = () => {
    this.setState({ fullscreenVisible: false})
  }

  render() {
    const size = 74
    return (
      <div style={styles.container}>
        <div style={styles.groupHeader}>
          {this.getGroupHeader()}
        </div>
        <div style={styles.photos}>
          {
            this.props.list
            && this.props.list
               .map((photo, index) =>
                <PhotoItem
                 key={index}
                 disableDeletion={true}
                 storagePath={photo.dbPath}
                 photo={photo}
                 width={size}
                 height={size}
                 onPress={this.onImagePress.bind(this, index)} />
                )
          }
          <PhotoSlideShow
            visible={this.state.fullscreenVisible}
            index={this.state.selectedIdx}
            photos={this.props.list}
            photosListDbPath={this.props.photosListDbPath}
            onClose={this.onSlideShowClose}/>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 12
  },
  groupHeader: {
    color: '#000'
  },
  photos: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 4,
    flexWrap: 'wrap'
  }
}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/photos/PhotosGroup.js